import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import {
  Monitor,
  Flower2,
  Waves,
  BadgeCheck,
  Lock,
  MapPin,
} from 'lucide-react'

const FEATURE_CARDS = [
  {
    id: 'work-areas',
    Icon: Monitor,
    labelEs: 'ÁREAS DE TRABAJO PRIVADAS',
    labelEn: 'PRIVATE WORK AREAS',
  },
  {
    id: 'gardens',
    Icon: Flower2,
    labelEs: 'JARDINES INTERIORES PRIVADOS',
    labelEn: 'PRIVATE INTERIOR GARDENS',
  },
  {
    id: 'pool',
    Icon: Waves,
    labelEs: 'PISCINA',
    labelEn: 'POOL',
  },
  {
    id: 'best-price',
    Icon: BadgeCheck,
    labelEs: 'MEJOR PRECIO GARANTIZADO',
    labelEn: 'BEST PRICE GUARANTEED',
  },
  {
    id: 'secure',
    Icon: Lock,
    labelEs: 'PAGO SEGURO',
    labelEn: 'SECURE PAYMENT',
  },
  {
    id: 'location',
    Icon: MapPin,
    labelEs: 'MEJOR UBICACIÓN',
    labelEn: 'BEST LOCATION',
  },
]

export function AmenitiesStrip() {
  const { i18n } = useTranslation()
  const es = i18n.language.startsWith('es')

  return (
    <section className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-10">
        {/* Section heading */}
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="mb-12 text-center text-2xl font-bold uppercase tracking-wide"
          style={{ color: '#0F2966', fontFamily: 'Montserrat, sans-serif' }}
        >
          {es
            ? 'Por qué elegir Hotel Boutique Nueva Valladolid'
            : 'Why choose Hotel Boutique Nueva Valladolid'}
        </motion.h2>

        {/* 3-column × 2-row feature grid */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10">
          {FEATURE_CARDS.map(({ id, Icon, labelEs, labelEn }, index) => (
            <motion.div
              key={id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.45, delay: index * 0.07, ease: 'easeOut' }}
              className="flex flex-col items-center gap-4 text-center"
            >
              {/* 60×60px circle container with navy border */}
              <div
                className="flex shrink-0 items-center justify-center"
                style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  border: '1px solid #0F2966',
                  backgroundColor: 'transparent',
                }}
              >
                <Icon
                  className="h-6 w-6"
                  style={{ color: '#0F2966' }}
                  strokeWidth={1.5}
                />
              </div>

              {/* Feature label */}
              <h3
                className="text-sm font-bold uppercase leading-snug tracking-wide"
                style={{
                  color: '#0F2966',
                  fontFamily: 'Montserrat, sans-serif',
                  maxWidth: '160px',
                }}
              >
                {es ? labelEs : labelEn}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
